import { GetEmailTemplatesRPC } from "@pulse/pulse-rpcs/lib/email-cycle/getEmailTemplatesRPC";
import { GetEmailTemplatesRPCClientImpl } from "@pulse/pulse-rpcs/lib/email-cycle/getEmailTemplatesRPCClientImpl";
import { GetAllEmailTemplatesRPCClientImpl } from "@pulse/pulse-rpcs/lib/email-cycle/getAllEmailTemplatesRPCClientImpl";
import { GetAllEmailTemplatesRPC } from "@pulse/pulse-rpcs/lib/email-cycle/getAllEmailTemplatesRPC";
import { MockGetAllEmailTemplatesRPCClientImpl } from "./MockGetAllEmailTemplatesRPCClientImpl";
import { APIClient } from "@surya-digital/tedwig";
import { MockGetEmailTemplatesRPCClientImpl } from "./MockGetEmailTemplatesRPCClientImpl";
import { MOCK } from "@pulse/shared-components";
import { CreateEmailTemplateRPC } from "@pulse/pulse-rpcs/lib/email-cycle/createEmailTemplateRPC";
import { CreateEmailTemplateRPCClientImpl } from "@pulse/pulse-rpcs/lib/email-cycle/createEmailTemplateRPCClientImpl";
import { GetEmailTemplateDetailsRPC } from "@pulse/pulse-rpcs/lib/email-cycle/getEmailTemplateDetailsRPC";
import { GetEmailTemplateDetailsRPCClientImpl } from "@pulse/pulse-rpcs/lib/email-cycle/getEmailTemplateDetailsRPCClientImpl";
import { MockGetEmailTemplateDetailsRPCClientImpl } from "./MockGetEmailTemplateDetailsRPCClientImpl";
import { MockCreateEmailTemplateRPCClientImpl } from "./MockCreateEmailTemplateRPClientImpl";
import { UpdateEmailTemplateRPC } from "@pulse/pulse-rpcs/lib/email-cycle/updateEmailTemplateRPC";
import { UpdateEmailTemplateRPCClientImpl } from "@pulse/pulse-rpcs/lib/email-cycle/updateEmailTemplateRPCClientImpl";
import { MockUpdateEmailTemplateRPCClientImpl } from "./MockUpdateEmailTemplateRPClientImpl";
import { DeleteEmailTemplateRPCClientImpl } from "@pulse/pulse-rpcs/lib/email-cycle/deleteEmailTemplateRPCClientImpl";
import { MockDeleteEmailTemplateRPCClientImpl } from "./MockDeleteEmailTemplateRPCClientImpl";
import { DeleteEmailTemplateRPC } from "@pulse/pulse-rpcs/lib/email-cycle/deleteEmailTemplateRPC";
import { GetCustomPlaceholdersRPC } from "@pulse/pulse-rpcs/lib/email-cycle/getCustomPlaceholdersRPC";
import { GetCustomPlaceholdersRPCClientImpl } from "@pulse/pulse-rpcs/lib/email-cycle/getCustomPlaceholdersRPCClientImpl";
import { MockGetCustomPlaceholdersRPCClientImpl } from "../../emailCycles/rpcs/MockGetCustomPlaceholdersRPCClientImpl";

export const useGetEmailTemplatesRPCClientImpl = (
  apiClient: APIClient,
): GetEmailTemplatesRPC =>
  MOCK.emailTemplates
    ? new MockGetEmailTemplatesRPCClientImpl()
    : new GetEmailTemplatesRPCClientImpl(apiClient);

export const useCreateEmailTemplateRPCClientImpl = (
  apiClient: APIClient,
): CreateEmailTemplateRPC =>
  MOCK.emailTemplates
    ? new MockCreateEmailTemplateRPCClientImpl()
    : new CreateEmailTemplateRPCClientImpl(apiClient);

export const useGetEmailTemplateDetailsRPCClientImpl = (
  apiClient: APIClient,
): GetEmailTemplateDetailsRPC =>
  MOCK.emailTemplates
    ? new MockGetEmailTemplateDetailsRPCClientImpl()
    : new GetEmailTemplateDetailsRPCClientImpl(apiClient);

export const useGetAllEmailTemplatesRPCClientImpl = (
  apiClient: APIClient,
): GetAllEmailTemplatesRPC =>
  MOCK.emailTemplates
    ? new MockGetAllEmailTemplatesRPCClientImpl()
    : new GetAllEmailTemplatesRPCClientImpl(apiClient);

export const useUpdateEmailTemplateRPCClientImpl = (
  apiClient: APIClient,
): UpdateEmailTemplateRPC =>
  MOCK.emailTemplates
    ? new MockUpdateEmailTemplateRPCClientImpl()
    : new UpdateEmailTemplateRPCClientImpl(apiClient);

export const useDeleteEmailTemplateRPCClientImpl = (
  apiClient: APIClient,
): DeleteEmailTemplateRPC =>
  MOCK.emailTemplates
    ? new MockDeleteEmailTemplateRPCClientImpl()
    : new DeleteEmailTemplateRPCClientImpl(apiClient);

export const useGetCustomPlaceholdersRPCClientImpl = (
  apiClient: APIClient,
): GetCustomPlaceholdersRPC =>
  MOCK.emailTemplates
    ? new MockGetCustomPlaceholdersRPCClientImpl()
    : new GetCustomPlaceholdersRPCClientImpl(apiClient);
